import { Country, CurrencyType } from "./models/Enums";

// Metadata de moneda por país/currency. Espejo de CurrencyInfo.cs del backend:
// mantener ambos sincronizados al agregar países.
export interface ICurrencyMetadata {
    iso: string;
    symbol: string;
    decimals: number;
}

const CURRENCY_MAP: { [key: number]: ICurrencyMetadata } = {
    [CurrencyType.CRC]: { iso: 'CRC', symbol: '₡',   decimals: 2 },
    [CurrencyType.USD]: { iso: 'USD', symbol: '$',   decimals: 2 },
    [CurrencyType.PAB]: { iso: 'PAB', symbol: 'B/.', decimals: 2 },
    [CurrencyType.MXN]: { iso: 'MXN', symbol: '$',   decimals: 2 },
    [CurrencyType.COP]: { iso: 'COP', symbol: '$',   decimals: 0 },
    [CurrencyType.NIO]: { iso: 'NIO', symbol: 'C$',  decimals: 2 },
    [CurrencyType.GTQ]: { iso: 'GTQ', symbol: 'Q',   decimals: 2 },
};

// Moneda por defecto de cada país (PA opera en USD).
const DEFAULT_CURRENCY_BY_COUNTRY: { [key: number]: CurrencyType } = {
    [Country.CR]: CurrencyType.CRC,
    [Country.PA]: CurrencyType.USD,
    [Country.MX]: CurrencyType.MXN,
    [Country.CO]: CurrencyType.COP,
    [Country.NI]: CurrencyType.NIO,
    [Country.GT]: CurrencyType.GTQ,
};

export class CurrencyInfo {

    static get(currency: CurrencyType): ICurrencyMetadata {
        return CURRENCY_MAP[currency] || CURRENCY_MAP[CurrencyType.CRC];
    }

    static symbol(currency: CurrencyType): string {
        return CurrencyInfo.get(currency).symbol;
    }

    static defaultForCountry(country: Country): CurrencyType {
        const currency = DEFAULT_CURRENCY_BY_COUNTRY[country];
        return currency !== undefined ? currency : CurrencyType.CRC;
    }

    static symbolForCountry(country: Country): string {
        return CurrencyInfo.symbol(CurrencyInfo.defaultForCountry(country));
    }
}
